import dynaForms from '@elab/core/utils/dynaForms';
import { reduceAction } from '@elab/core/store/helpers';
import { initialState as dynaInitialState } from '@elab/core/utils/dynaForms/reducers';

import types, { storeName } from './types';

export const initialState = () => ({
    ...dynaInitialState(),
    timeout: 0,
    verificationState: 'DEFAULT',
    sessionId: null,
    isRetryDisabled: false,
    showPhoneVerificationField: false,
});
const dynaFormReduce = dynaForms.createReducer(storeName);
const reducers = (state = initialState(), action) => {
    state = dynaFormReduce(state, action);

    switch (action.type) {
        case types.SET_TIMEOUT:
            return reduceAction(state, 'timeout', action.payload);

        case types.ERROR_VERIFICATION:
            return {
                ...state,
                verificationState: 'ERROR',
                errorCode: action.payload.errorCode,
                errorMessage: action.payload.errorMessage,
            };
        case types.CODE_EXPIRED:
            return {
                ...state,
                verificationState: 'ERROR',
                errorMessage: action.payload.errorMessage,
            };
        case types.RESTART_VERIFICATION:
            return {
                ...state,
                timeout: 0,
                verificationState: 'DEFAULT',
                errorCode: null,
                errorMessage: null,
                isRetryDisabled: true,
            };
        case types.SUCCESS_VERIFIED:
            return {
                ...state,
                verificationState: 'SUCCESS',
                sessionId: action.payload.sessionId,
            };

        case types.SET_VERIFICATION_STATE:
            return reduceAction(state, 'verificationState', action.payload);

        case types.CHANGE_IS_RETRY_DISABLED:
            return reduceAction(state, 'isRetryDisabled', false);

        case types.SHOW_PHONE_VERIFICATION_FIELD:
            return reduceAction(state, 'showPhoneVerificationField', true);

        case types.RESET_FORM:
            return {
                ...state,
                timeout: 0,
                verificationState: 'DEFAULT',
                sessionId: null,
                isRetryDisabled: true,
                showPhoneVerificationField: false,
            };

        default:
            return state;
    }
};

export default reducers;
